import { render, staticRenderFns } from "./Produtividade.vue?vue&type=template&id=47dbd754&scoped=true&"
import script from "./Produtividade.vue?vue&type=script&lang=js&"
export * from "./Produtividade.vue?vue&type=script&lang=js&"
import style0 from "./Produtividade.vue?vue&type=style&index=0&id=47dbd754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dbd754",
  null
  
)

export default component.exports